<template>
    <span class='fill-height image-mobile-app'>
        <div class="logo">
            <logo></logo>
        </div>
        <div class="d-flex mx-auto icon-app">
            <a href="">
                <img src="/images/appstore.png" alt="">
            </a>
            <a href="">
                <img src="/images/googleplay.png" alt="">
            </a>
        </div>
    </span>
</template>

<script>
import logo from './Logo.vue'
export default {
  name: 'ImageMobileApp',
  components: { logo },
  data: () => ({})
}
</script>

<style lang="scss">
    .image-mobile-app{
        background: url("/images/login.png") no-repeat;
        background-size: cover;
        min-height: 750px;
        .logo{
            position: absolute;
            top: 5vh;
            left: 25%;
            transform: translateX(-50%);
            .logo-img{
                width: 20vw;
            }
        }
        .icon-app{
            position: absolute;
            bottom: 5vh;
            left: 25%;
            transform: translateX(-50%);
            a{
                margin: 0 1.5rem;
                transition: all 0.3s ease;
                @include bigScreen{
                    margin: 0 2.5rem;
                }
                img{
                    width: 12vw;
                }
                &:hover{
                    img{
                        transform: scale(1.05);
                    }
                }
            }
        }
        &::before{
            content: '';
            position: absolute;
            height: 100%;
            width: 50%;
            background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.3));
        }
    }
</style>
